import ButtonCircle from '@/components/ButtonCircle';

type ContentTileProps = {
  title: string;
  content: string;
  text: string;
  externalLink: string;
  link: string;
};

const ContentTile: React.FC<ContentTileProps> = ({
  title,
  content,
  text,
  externalLink,
  link,
}) => {
  const ctaLink = externalLink || link;

  return (
    <div className="content-tile">
      <h4 className="content-tile__heading">{title}</h4>
      <div
        className="content-tile__content"
        dangerouslySetInnerHTML={{ __html: content }}
      />
      {externalLink && text ? (
        <a
          className="content-tile__cta button button--external button--primary"
          href={externalLink}
          target="_blank"
        >
          {text}
          <ButtonCircle arrowHeight={13} arrowWidth={17} />
        </a>
      ) : link && text ? (
        <a className="content-tile__cta button button--primary" href={ctaLink}>
          {text}
          <ButtonCircle arrowHeight={13} arrowWidth={17} />
        </a>
      ) : null}
    </div>
  );
};

export default ContentTile;
